<template>
  <div class="date-range-wrapper">
    <div class="input-group date-group">
      <input
        type="text"
        ref="startInput"
        class="form-control"
        name="start"
        :placeholder="dateOptions.placeholder"
        :maxlength="dateOptions.format.length"
        :class="{ 'input-error-date': erroFormato.start, 'input-valid-date': validoFormato.start }"
        @input="processarValorInserido"
        @blur="emitChange"
      />
      <span ref="calendarStartBtn" class="input-group-addon calendar-addon" @click="abrirCalendario('start')">
        <i class="fa fa-calendar"></i>
      </span>
    </div>
    <span v-show="!onlyStart" class="ate-separator"> até </span>
    <div v-show="!onlyStart" class="input-group date-group">
      <input
        type="text"
        ref="endInput"
        class="form-control"
        name="end"
        :placeholder="dateOptions.placeholder"
        :maxlength="dateOptions.format.length"
        :class="{ 'input-error-date': erroFormato.end, 'input-valid-date': validoFormato.end }"
        @input="processarValorInserido"
        @blur="emitChange"
      />
      <span ref="calendarEndBtn" class="input-group-addon calendar-addon" @click="abrirCalendario('end')">
        <i class="fa fa-calendar"></i>
      </span>
    </div>
    <div class="gerar-wrapper">
      <transition-group name="slide">
        <button v-if="gerarEnabled" class="btn blue" type="button" @click="apply" key="enabledbuttondate">
          {{ buttonDescription }}
        </button>
        <button v-if="!gerarEnabled" class="btn blue disabled" type="button" key="disabledbuttondate">
          Carregando
        </button>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fluxo-caixa-date-range-input',
  props: {
    startDate:         { default: null },
    endDate:           { default: null },
    minDate:           { default: "" },
    maxDate:           { default: "" },
    buttonDescription: { default: "Gerar" },
    gerarEnabled:      { default: false },
    startView:         { default: -1 },
    onlyStart:         { default: false },
    equalDates:        { default: false }
  },
  data() {
    return {
      start: null,
      end: null,
      erroFormato:  { start: false, end: false },
      validoFormato: { start: false, end: false },
      dayOptions:     { format: 'DD/MM/YYYY', placeholder: 'dd/MM/aaaa', startViewIndex: 0 },
      monthOptions:   { format: 'MM/YYYY',    placeholder: 'MM/aaaa',    startViewIndex: 1 },
      yearOptions:    { format: 'YYYY',       placeholder: 'aaaa',       startViewIndex: 2 },
      defaultOptions: { format: 'DD/MM/YYYY', placeholder: 'dd/MM/aaaa', startViewIndex: 1 }
    };
  },
  computed: {
    dateOptions() {
      if (this.startView == 0) return this.dayOptions;
      if (this.startView == 1) return this.monthOptions;
      if (this.startView == 2) return this.yearOptions;
      return this.defaultOptions;
    }
  },
  watch: {
    start(val) { this.$emit('start-date-changed', val); },
    end(val)   { this.$emit('end-date-changed', val); },
    startView() {
      if (this.start && this.end) {
        this.start = new Date(this.start.getFullYear(), this.start.getMonth(), 1);
        this.end   = new Date(this.end.getFullYear(), this.end.getMonth() + 1, 0);
        this._setInputValues();
        this._initCalendarios();
      }
    },
    startDate(val) {
      if (val && !isNaN(val.getTime())) {
        this.start = val;
        this.$refs.startInput.value = moment(val).format(this.dateOptions.format);
      }
    },
    endDate(val) {
      if (val && !isNaN(val.getTime())) {
        this.end = val;
        this.$refs.endInput.value = moment(val).format(this.dateOptions.format);
      }
    }
  },
  methods: {
    _setInputValues() {
      this.$refs.startInput.value = moment(this.start).format(this.dateOptions.format);
      if (!this.onlyStart && this.end)
        this.$refs.endInput.value = moment(this.end).format(this.dateOptions.format);
    },
    _mascarar(digitos) {
      var fmt = this.dateOptions.format;
      var result = '';
      var di = 0;
      for (var i = 0; i < fmt.length && di < digitos.length; i++) {
        result += fmt[i] === '/' ? '/' : digitos[di++];
      }
      return result;
    },
    processarValorInserido(e) {
      var input = e.target;
      var nome  = input.name;

      var digitos   = input.value.replace(/\D/g, '');
      var mascarado = this._mascarar(digitos);
      input.value   = mascarado;

      var formato = this.dateOptions.format;
      if (mascarado.length < formato.length) {
        this.erroFormato[nome]  = false;
        this.validoFormato[nome] = false;
        return;
      }

      var data = moment(mascarado, formato, true);
      if (data.isValid()) {
        this.erroFormato[nome]  = false;
        this.validoFormato[nome] = true;
      } else {
        this.erroFormato[nome]  = true;
        this.validoFormato[nome] = false;
      }
    },
    emitChange(e) {
      var nome   = e.target.name;
      var valor  = e.target.value;
      var formato = this.dateOptions.format;

      if (!valor.trim()) {
        this._restaurarCampo(e.target, nome);
        return;
      }

      var data = moment(valor, formato, true);
      if (!data.isValid()) {
        toastr.error('Data inválida. O formato esperado é ' + this.dateOptions.placeholder + '.');
        this._restaurarCampo(e.target, nome);
        return;
      }

      var finalDate = data.toDate();
      if (this.dateOptions.startViewIndex > 0) {
        finalDate = nome === 'start'
          ? moment(finalDate).startOf('month').toDate()
          : moment(finalDate).endOf('month').toDate();
      }

      if (nome === 'start') this.start = finalDate;
      else this.end = finalDate;

      this.erroFormato[nome]  = false;
      this.validoFormato[nome] = false;
    },
    _restaurarCampo(input, nome) {
      var anterior = nome === 'start' ? this.start : this.end;
      input.value = anterior ? moment(anterior).format(this.dateOptions.format) : '';
      this.erroFormato[nome]  = false;
      this.validoFormato[nome] = false;
    },
    apply() {
      if (!this.start || (!this.onlyStart && !this.end)) {
        this.$emit('error-input', 3);
        return;
      }
      if (!this.onlyStart) {
        if (!this.equalDates && this.start.toString() === this.end.toString()) {
          this.$emit('error-input', 1);
          return;
        }
        if (this.start > this.end) {
          this.$emit('error-input', 2);
          return;
        }
      }
      this.$emit('apply', { start: this.start, end: this.end });
    },
    abrirCalendario(nome) {
      var btn  = nome === 'start' ? this.$refs.calendarStartBtn : this.$refs.calendarEndBtn;
      var data = nome === 'start' ? this.start : this.end;
      if (data) window.$(btn).datepicker('update', data);
      window.$(btn).datepicker('show');
    },
    _rangeCallback(granularidade) {
      var vm = this;
      return function(date) {
        var start = vm.start;
        var end   = vm.end;
        if (!start || !end) return { enabled: true };

        var norm = function(d) {
          if (granularidade === 'day')   return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
          if (granularidade === 'month') return new Date(d.getFullYear(), d.getMonth(), 1).getTime();
          return new Date(d.getFullYear(), 0, 1).getTime();
        };

        var t  = norm(date);
        var t0 = norm(start);
        var t1 = norm(end);

        if (t === t0 && t === t1) return { enabled: true, classes: 'range-start range-end' };
        if (t === t0)             return { enabled: true, classes: 'range-start' };
        if (t === t1)             return { enabled: true, classes: 'range-end' };
        if (t > t0 && t < t1)    return { enabled: true, classes: 'range-between' };
        return { enabled: true };
      };
    },
    _initCalendarios() {
      var vm = this;
      var views = ['days', 'months', 'years'];
      var startView = views[this.dateOptions.startViewIndex] || 'days';
      var dpFormat  = this.dateOptions.format.toLowerCase();

      try { window.$(this.$refs.calendarStartBtn).datepicker('destroy'); } catch(e) {}
      try { window.$(this.$refs.calendarEndBtn).datepicker('destroy'); } catch(e) {}

      var opts = {
        language: 'pt-BR',
        orientation: 'bottom left',
        format: dpFormat,
        startView: startView,
        minViewMode: startView,
        autoClose: true,
        startDate: this.minDate || undefined,
        endDate: this.maxDate || undefined,
        beforeShowDay:   this._rangeCallback('day'),
        beforeShowMonth: this._rangeCallback('month'),
        beforeShowYear:  this._rangeCallback('year')
      };

      var $startBtn = window.$(this.$refs.calendarStartBtn);
      $startBtn.datepicker(opts).on('changeDate', function(e) {
        var date = e.date;
        vm.start = date;
        vm.$refs.startInput.value = moment(date).format(vm.dateOptions.format);
        $startBtn.datepicker('hide');
        if (!vm.onlyStart)
          window.$(vm.$refs.calendarEndBtn).datepicker('show');
      });
      $startBtn.data('datepicker').picker.addClass('fluxo-caixa-range-picker');

      var $endBtn = window.$(this.$refs.calendarEndBtn);
      $endBtn.datepicker(opts).on('changeDate', function(e) {
        var date = e.date;
        if (vm.dateOptions.startViewIndex > 0)
          date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        vm.end = date;
        vm.$refs.endInput.value = moment(date).format(vm.dateOptions.format);
        $endBtn.datepicker('hide');
      });
      $endBtn.data('datepicker').picker.addClass('fluxo-caixa-range-picker');
    },
    _protegerInput(input) {
      if (!input) return null;
      input.removeAttribute('readonly');
      var obs = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'readonly')
            input.removeAttribute('readonly');
        });
      });
      obs.observe(input, { attributes: true, attributeFilter: ['readonly'] });
      return obs;
    }
  },
  mounted() {
    if (window.$.fn.datepicker && window.$.fn.datepicker.dates) {
      window.$.fn.datepicker.dates['pt-BR'] = {
        days: ["Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado"],
        daysShort: ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],
        daysMin: ["Do","Se","Te","Qu","Qu","Se","Sa"],
        months: ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],
        monthsShort: ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],
        today: "Hoje",
        clear: "Limpar"
      };
    }
    this.start = this.startDate || moment().subtract(1, 'days').toDate();
    this.end   = this.endDate   || moment().toDate();
    this._setInputValues();
    this.$nextTick(() => {
      this._obsStart = this._protegerInput(this.$refs.startInput);
      this._obsEnd   = this._protegerInput(this.$refs.endInput);
      this._initCalendarios();
    });
  },
  beforeDestroy() {
    if (this._obsStart) this._obsStart.disconnect();
    if (this._obsEnd)   this._obsEnd.disconnect();
    try { window.$(this.$refs.calendarStartBtn).datepicker('destroy'); } catch(e) {}
    try { window.$(this.$refs.calendarEndBtn).datepicker('destroy'); } catch(e) {}
  }
};
</script>

<style>
/* escopo: só afeta datepickers do fluxo-caixa-date-range-input */
.fluxo-caixa-range-picker td.range-start,
.fluxo-caixa-range-picker td.range-end {
  background-color: #337ab7 !important;
  color: #fff !important;
}
.fluxo-caixa-range-picker td.range-start { border-radius: 4px 0 0 4px; }
.fluxo-caixa-range-picker td.range-end   { border-radius: 0 4px 4px 0; }
.fluxo-caixa-range-picker td.range-start.range-end { border-radius: 4px; }
.fluxo-caixa-range-picker td.range-between {
  background-color: #d4e8f7 !important;
  color: #333 !important;
  border-radius: 0;
}
.fluxo-caixa-range-picker td span.range-start,
.fluxo-caixa-range-picker td span.range-end {
  background-color: #337ab7 !important;
  color: #fff !important;
}
.fluxo-caixa-range-picker td span.range-between {
  background-color: #d4e8f7 !important;
  color: #333 !important;
}
</style>

<style scoped>
.date-range-wrapper {
  display: flex;
  align-items: center;
  width: 408px;
  gap: 8px;
}
.date-group {
  flex: 1;
  min-width: 0;
}
.ate-separator {
  white-space: nowrap;
  color: #555;
  flex-shrink: 0;
}
.gerar-wrapper {
  flex-shrink: 0;
}
.input-error-date {
  border-color: #e73d4a !important;
  background-color: #fff0f1;
}
.input-valid-date {
  border-color: #5cb85c !important;
  background-color: #f0fff0;
}
.calendar-addon {
  cursor: pointer;
}
.calendar-addon:hover {
  background-color: #e8e8e8;
}
</style>
